import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// columns: array
// sortColumn: object
// onSort: function

class TableHeader extends Component {
  raiseSort = (path) => {
    const { disableAllSort, onSort } = this.props;

    if (!disableAllSort) {
      const sortColumn = { ...this.props.sortColumn };
      if (sortColumn.path === path)
        sortColumn.order = sortColumn.order === "asc" ? "desc" : "asc";
      else {
        sortColumn.path = path;
        sortColumn.order = "asc";
      }
      onSort(sortColumn);
    }
  };

  renderSortIcon = (column) => {
    const { sortColumn, disableAllSort } = this.props;

    if (!disableAllSort && !column.disableSort) {
      if (column.path !== sortColumn.path)
        return <FontAwesomeIcon icon="sort" className="fa-fw ml-0" />;
      if (sortColumn.order === "asc")
        return <FontAwesomeIcon icon="sort-up" className="fa-fw ml-0" />;
      return <FontAwesomeIcon icon="sort-down" className="fa-fw ml-0" />;
    }
    return "";
  };

  render() {
    const { columns } = this.props;
    return (
      <thead>
        <tr>
          {columns.map((column) => (
            <th
              className={column.thClassName + " pointer-cursor bg-lightgray"}
              key={`tableThKey_${column.path || column.key}`}
              onClick={
                column.disableSort
                  ? column.customHeaderClick
                    ? () => column.customHeaderClick()
                    : () => {}
                  : () => this.raiseSort(column.path)
              }
              colSpan={!column.thColSpan ? "1" : column.thColSpan}
            >
              {column.label}
              {this.renderSortIcon(column)}
            </th>
          ))}
        </tr>
      </thead>
    );
  }
}

export default TableHeader;
